
import lottie from 'vue-lottie/src/lottie.vue'

import { mapState } from 'vuex'

export default {
  name: 'Loader',
  components: {
    lottie
  },
  props: {
    lottieData: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: 350
    },
    height: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      anim: null,
      renderer: 'svg',
      options: {
        animationData: this.lottieData
      }
    }
  },
  computed: {
    ...mapState([ 'loading' ]),
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    }
  }
}
